// קביעת סיסמה דרך קישור חד-פעמי (משתמש חדש או איפוס).
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { ErrorBox, Field, Loading } from '../components/ui';

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get('t') ?? '';
  const [info, setInfo] = useState<{ email: string; name: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/api/auth/password-link?t=${encodeURIComponent(token)}`).then(setInfo).catch((e) => setError(e.message)); }, [token]);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pw !== pw2) { setError('הסיסמאות אינן זהות'); return; }
    setBusy(true); setError(null);
    try { await api.post('/api/auth/set-password', { token, password: pw }); setDone(true); } catch (err: any) { setError(err.message); } finally { setBusy(false); }
  };
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100%', padding: 16 }}>
      <div className="card stack" style={{ width: 'min(400px, 100%)' }}>
        <h1>קביעת סיסמה</h1>
        {!info && !error && <Loading />}
        <ErrorBox error={error} />
        {done ? (
          <div className="stack"><div className="alert ok">הסיסמה נקבעה.</div><a className="btn primary" href="/login">לכניסה</a></div>
        ) : info && (
          <form className="stack" onSubmit={submit}>
            <div className="small">משתמש: <span className="ltr">{info.email}</span></div>
            <input type="email" value={info.email} autoComplete="username" readOnly hidden />
            <Field label="סיסמה חדשה" hint="10 תווים לפחות"><input type="password" className="ltr" minLength={10} required value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" /></Field>
            <Field label="אימות סיסמה"><input type="password" className="ltr" minLength={10} required value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" /></Field>
            <button className="btn primary" disabled={busy}>{busy ? 'שומר…' : 'שמירה'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
